import { render, staticRenderFns } from "./results-test.vue?vue&type=template&id=54e8c09e&scoped=true&"
import script from "./results-test.vue?vue&type=script&lang=js&"
export * from "./results-test.vue?vue&type=script&lang=js&"
import style0 from "./results-test.vue?vue&type=style&index=0&id=54e8c09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8c09e",
  null
  
)

export default component.exports